import { render, staticRenderFns } from "./aCardKpi.vue?vue&type=template&id=03d96a18"
import script from "./aCardKpi.vue?vue&type=script&lang=js"
export * from "./aCardKpi.vue?vue&type=script&lang=js"
import style0 from "./aCardKpi.vue?vue&type=style&index=0&id=03d96a18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
